import axios from "axios";
import customAxios from "../../customHook/customAxios";

import { getAuthHeader } from '../../utils';

export const v2_user_by_roles = async (roleId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/users/role/${roleId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_all_user = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/users`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_user_by_designations = async (designationId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/users/designation/${designationId}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_user_for_chat = async (keyword) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/users/chat?keyword=${keyword}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
